import { Component, Input, OnInit } from '@angular/core';
import { lightness } from 'src/app/helpers/colors';
import { ColorBrightness, PlantColor } from '../../core/types/plant-color';

@Component({
    selector: 'app-color-field',
    templateUrl: './color-field.component.html',
    styleUrls: ['./color-field.component.scss'],
    standalone: false
})
export class ColorFieldComponent {
  _color: PlantColor & ColorBrightness;
  @Input() set color(color: PlantColor & ColorBrightness) {
    this._color = !color ? null : {
      ...color,
      brightness: color.brightness || lightness(color.colorval)
    };
  }

  get color() {
    return this._color;
  }

  @Input() selected = false;
  @Input() behavior: 'static' | 'interactive' = 'interactive';
  constructor() { }
}
